import { type CSSProperties } from 'react';

interface ColorSwatchProps {
    color: {
        value: CSSProperties['background'];
        variable_name: string;
        uses: string;
    };
}

export const ColorSwatch = ({ color }: ColorSwatchProps) => (
    <div className="sds_color__container">
        <div className="sds_color__swatch" style={{ background: color.value }} />
        <div className="sds_color__text">
            <div className="sds_color__text__name">{color.variable_name}</div>
            <div className="sds_color__text__use">{color.uses}</div>
            <div className="sds_color__text__value">{color.value}</div>
            <input
                className="sds_color__input padding__left--small"
                value={color.variable_name}
                onFocus={(e) => e.target.select()}
                readOnly
            />
        </div>
    </div>
);
